<span (click)="logout()">
  <ion-label>{{ 'app.profile.logout' | translate }}</ion-label>
</span>
